import * as React from "react";

import DataTable from "react-data-table-component-with-filter";
import { Link, useNavigate } from "react-router-dom";
import { RiFilterLine } from "react-icons/ri";

import Paper from "../../Components/Paper";
import Button from "../../Components/Button";
import FilterComponent from "../../Components/FilterComponent";
import { config } from "./Helper";
import { useLoader } from "../../Context/LoaderContext";
import axiosInstance from "../../Api/Axios";

import { handleDownload } from "../../Functions/Utils";

import "./ListFinancingRequest.scss";

const customStyles = {
  headCells: {
    style: {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      background: "#e75043",
      paddingBottom: "12px",
      paddingTop: "4px",
    },
  },
  cells: {
    style: {
      color: "#000",
      fontSize: "15px",
    },
  },
};

const ListFinancingRequest = () => {
  const [listFinancingRequest, setListFinancingRequest] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [withFilter, setWithFilter] = React.useState(false);

  const { setIsLoading } = useLoader();

  const navigate = useNavigate();

  const onView = (id) => {
    navigate(`/list-financing-request/show-financing-request/${id}`);
  };

  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/financing-request`)
      .then((response) => {
        setIsLoading(false);
        setListFinancingRequest(response.data.data || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  const filteredItems = listFinancingRequest.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  const subHeaderComponent = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleDownloadPdf = () => {
    handleDownload(
      "list_financing_request",
      "Demande-de-financement"
    );
  };

  return (
    <Paper>
      <div className="wrap-tabs-offer">
        <h1 className="mb-32">
          Demande <span className="font-normal">de financement</span>
        </h1>
        <div className="box_link_funding">
          <Link to="/list-financing-request/simulateur-step-1">
            <Button variant="dark">Simuler</Button>
          </Link>
        </div>
        {/* <div className="box_link_funding">
          <Link to="/list-simulations">
            <Button variant="dark">Simulations</Button>
          </Link>
        </div> */}
        {listFinancingRequest.length > 0 && (
          <div className="wrap-btn-action">
            <Button variant="dark" view="outline" onClick={handleDownloadPdf}>
              Imprimer
            </Button>
            <Button
              onClick={() => setWithFilter((prev) => !prev)}
              variant="dark"
              view="outline"
            >
              {withFilter ? "Masquer filtre" : "Afficher filtre"}
              <RiFilterLine />
            </Button>
          </div>
        )}

        <div className="print-container">
          <DataTable
            columns={config(withFilter, onView)}
            data={filteredItems}
            customStyles={customStyles}
            pagination
            subHeader
            highlightOnHover
            subHeaderComponent={subHeaderComponent}
            noDataComponent={<div> Pas d'informations disponibles</div>}
            paginationComponentOptions={{
              rowsPerPageText: "Lignes par page:",
              rangeSeparatorText: "de",
              noRowsPerPage: false,
              selectAllRowsItem: false,
              selectAllRowsItemText: "tous",
            }}
          />
        </div>
      </div>
    </Paper>
  );
};

export default ListFinancingRequest;
